import FieldTennis from "../assets/tennisfield.webp";

function TennisSection() {
    return (
        <section
            aria-label="Tennis section"
            className="relative bg-[#000] -space-y-[16vw]"
        >
            <div className="flex flex-col gap-28 z-10 relative h-full justify-top">
                <div className="flex flex-col z-20">
                    <h2 className="font-[900] text-light text-[7vw] text-center">TENNIS</h2>
                    <h2 className="font-[900] text-yellow text-[7vw] text-center -mt-[7vw]">COSA CALCOLIAMO?</h2>
                    <p className="font-[900] text-light text-[3vw] text-center">
                        Zone di rimbalzo, prime e heatmap
                    </p>
                </div>
            </div>
            <div className="
                    w-full overflow-hidden group h-full pt-[8vw]
                    sm:pt-0
            ">
                <img
                src={FieldTennis}
                alt="Campo da tennis"
                className="
                        object-cover scale-150 object-top w-full h-full
                        sm:scale-100
                        "
            />
            </div>
        </section>
    );
}

export default TennisSection;
